import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[rdcAnalyticsData]',
    standalone: true,
})
export class AnalyticsDataDirective implements OnInit {
    @Input() rdcAnalyticsData: string;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        this.renderer.setAttribute(
            this.elementRef.nativeElement,
            'rdcAnalyticsData',
            this.rdcAnalyticsData
        );
    }
}
